"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCaster = void 0;
const const_type_1 = require("./const-type");
const date_type_1 = require("./date-type");
const number_type_1 = require("./number-type");
const string_type_1 = require("./string-type");
const object_type_1 = require("./object-type");
const array_type_1 = require("./array-type");
const boolean_type_1 = require("./boolean-type");
const union_type_1 = require("./union-type");
const caster_cache_1 = require("./caster-cache");
const availableCasters = {
    Boolean: boolean_type_1.booleanType,
    Const: const_type_1.constType,
    Date: date_type_1.dateType,
    Number: number_type_1.numberType,
    String: string_type_1.stringType,
    Object: object_type_1.objectType,
    Array: array_type_1.arrayType,
    Union: union_type_1.unionType
};
function createCaster(declaration, validateOptions, circularCache = caster_cache_1.createCache()) {
    if (declaration === null || typeof declaration !== 'object') {
        throw new Error('First argument (declaration) must be an object.');
    }
    const matchingCaster = availableCasters[declaration.type];
    if (matchingCaster === undefined) {
        const typeNames = Object.keys(availableCasters)
            .sort()
            .map((format) => `"${format}"`);
        const firstTypeNames = typeNames.slice(0, -1);
        const lastTypeName = typeNames.slice(-1);
        const typesLiteral = firstTypeNames.join(', ') + ' or ' + lastTypeName;
        throw new Error(`"type" property on declaration must be ${typesLiteral} (unknown type = ${declaration.type}).`);
    }
    const circularCaster = circularCache.get(declaration);
    if (circularCaster !== undefined) {
        return circularCaster;
    }
    return matchingCaster(declaration, validateOptions, circularCache);
}
exports.createCaster = createCaster;
